function patientMap(patients, key) {
	var map = {}
	patients.forEach((patient) => {
		if (patient[key] != null)
			map[patient[key]] = patient
	})
	return map
}

export function patientEmailMap(patients) {
	return patientMap(patients, 'email')
}

export function patientPhoneMap(patients) {
	return patientMap(patients, 'phone')
}
